export const NAVIGATION_SOURCE = {
  SIGNUP: "signup"
};
